import { UserRole } from "constants/userRole";
import withContractsLibraryAccess from "hoc/withContractsLibraryAccess";
import WithRoleProtection from "hoc/withRoleProtection";
import { PublicLayout } from "layout/components/PublicLayout";
import { CreateFeeSchedulePage } from "pages/CreateFeeSchedule";
import { CreateOrder } from "pages/CreateOrder";
import { CopyOrder } from "pages/CreateOrder/CopyOrder";
import { ReviewOrder } from "pages/CreateOrder/ReviewOrder";
import { CustomizePage } from "pages/Customize";
import { ListCustoms } from "pages/Customize/ListCustoms";
import { FeeSchedulePage } from "pages/FeeSchedule";
import { HospitalPage } from "pages/Hospitals";
import { CreateHospitalPage, EditHospitalPage } from "pages/HospitalsPage";
import { NotFound } from "pages/NotFound";
import { OrderOverview } from "pages/OrderOverview";
import { PayMoreSection } from "pages/OrderOverview/components/PayNow/PayMoreSection";
import { Steps, OrderPayMoreSteps } from "pages/OrderOverview/utils/constants";
import { OrderUpdate } from "pages/OrderUpdate";
import { Steps as OrderUpdateSteps } from "pages/OrderUpdate/utils/constants";
import { OrderViewPage } from "pages/OrderView";
import { PatientsPage } from "pages/Patients";
import ContractPreviewPage from "pages/PayerRules/contracts/ContractPreview";
import ContractViewPage from "pages/PayerRules/contracts/ContractView";
import CreateContractFeeSchedulePage from "pages/PayerRules/contracts/CreateContract";
import EditContractFeeSchedulePage from "pages/PayerRules/contracts/EditContract";
import {
  MarketPricesUpload,
  MarketPricesEdit,
  MarketPricesView,
  AllMarketPrices,
} from "pages/PayerRules/marketPrices";
import { EditPayerRulesPage, CopyPayerRulesPage } from "pages/PayerRulesPage";
import { CopyCaseRateRulesPage } from "pages/PayerRulesPage/CopyCaseRateRulesPage";
import { CreatePayerPage } from "pages/PayerRulesPage/CreatePayerPage";
import { CreatePayerRulesPage } from "pages/PayerRulesPage/CreatePayerRulesPage";
import { EditCaseRateRulesPage } from "pages/PayerRulesPage/EditCaseRateRulesPage";
import { EditPayerPage } from "pages/PayerRulesPage/EditPayerPage";
import { CreateProvider } from "pages/Providers/CreateProvider";
import { EditProvider } from "pages/Providers/EditProvider";
import { Reports } from "pages/Reports";
import { RevenueDashboard } from "pages/RevenueDashboard";
import { CreateEditUser } from "pages/UserPages/CreateEditUser";
import { UsersPage } from "pages/Users";
import { VerificationPage } from "pages/VerificationPage";
import { ConfirmationSuccess } from "pages/VerificationPage/components/HospitalConfirmation/ConfirmationSuccess";
import { VerificationSteps } from "pages/VerificationPage/utils/constants";
import ViewHospitals from "pages/ViewHospitals/ViewHospitals";
import React from "react";
import { RouteObject } from "react-router-dom";

import { AppLayout } from "../layout/components/AppLayout";
import { Chatbot } from "../pages/Chatbot";
import ChatViewPage from "../pages/Chatbot/ChatViewPage";
import { CreateModelPage } from "../pages/Chatbot/CreateModelPage";
import { EditFilePage } from "../pages/Chatbot/EditFilePage";
import { EditModelPage } from "../pages/Chatbot/EditModelPage";
import { FileDetailPage } from "../pages/Chatbot/FileDetailPage";
import ModelViewPage from "../pages/Chatbot/ModelViewPage";
import { UploadFilePage } from "../pages/Chatbot/UploadFilePage";
import { DirectPay } from "../pages/DirectPay";
import { HstSyncPage } from "../pages/HstSync";
import { LoginPage, ValidateMFA } from "../pages/Login";
import { OrdersPage } from "../pages/Orders";
import { PayerRules } from "../pages/PayerRules";
import CustomCptVolumeDetailPage from "../pages/PayerRules/CustomCptVolumeDetailPage";
import { CopyExplodingFeeSchedulePage } from "../pages/PayerRulesPage/CopyExplodingFeeSchedulePage";
import { CopyInpatientRulesetPage } from "../pages/PayerRulesPage/CopyInpatientRulesetPage";
import { CopyPackagesPage } from "../pages/PayerRulesPage/CopyPackagesPage";
import { CreateCaseRateRulesPage } from "../pages/PayerRulesPage/CreateCaseRateRulesPage";
import { CreateExplodingFeeSchedulePage } from "../pages/PayerRulesPage/CreateExplodingFeeSchedulePage";
import { CreateInpatientRulesetPage } from "../pages/PayerRulesPage/CreateInpatientRulesetPage";
import { CreateLesserOfChargesPage } from "../pages/PayerRulesPage/CreateLesserOfChargesPage";
import { CreatePackagesPage } from "../pages/PayerRulesPage/CreatePackagesPage";
import { CreateProfessionalModifierPage } from "../pages/PayerRulesPage/CreateProfessionalModifierPage";
import { CreateProfessionalRulesetPage } from "../pages/PayerRulesPage/CreateProfessionalRulesetPage";
import { EditExplodingFeeSchedulePage } from "../pages/PayerRulesPage/EditExplodingFeeSchedulePage";
import { EditInpatientRulesetPage } from "../pages/PayerRulesPage/EditInpatientRulesetPage";
import { EditLesserOfChargesPage } from "../pages/PayerRulesPage/EditLesserOfChargesPage";
import { EditPackagesPage } from "../pages/PayerRulesPage/EditPackagesPage";
import { EditProfessionalModifierPage } from "../pages/PayerRulesPage/EditProfessionalModifierPage";
import { EditProfessionalRulesetPage } from "../pages/PayerRulesPage/EditProfessionalRulesetPage";
import { HierarchyRulesetPage } from "../pages/PayerRulesPage/HierarchyRulesetPage";

export const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/ValidateMFA",
    element: <ValidateMFA />,
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "/hospitals",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<HospitalPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "new",
            element: (
              <WithRoleProtection
                component={<CreateHospitalPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "edit/:id",
            element: (
              <WithRoleProtection
                component={<EditHospitalPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          { path: "view/:id", element: <ViewHospitals /> },
          { path: "view/:id/orders", element: <ViewHospitals /> },
          { path: "view/:id/providers", element: <ViewHospitals /> },
          { path: "view/:id/analytics", element: <ViewHospitals /> },
          { path: "view/:id/patients", element: <ViewHospitals /> },
          { path: "view/:id/reports", element: <ViewHospitals /> },
          { path: "view/:id/patient-chats", element: <ViewHospitals /> },
          { path: "view/:id/contracts", element: <ViewHospitals /> },
          {
            path: "view/:id/contracts/smart-insights",
            element: <ViewHospitals />,
          },
          { path: "view/:id/contracts/library", element: <ViewHospitals /> },
          {
            path: "view/:id/contracts/base-rate-files",
            element: <ViewHospitals />,
          },
          {
            path: "view/:id/contracts/claims",
            element: <ViewHospitals />,
          },
          {
            path: "view/:id/contracts/estimate-insights",
            element: <ViewHospitals />,
          },
          {
            path: "view/:id/contracts/claim-analysis",
            element: <ViewHospitals />,
          },
          {
            path: "view/:id/contracts/new",
            element: React.createElement(
              withContractsLibraryAccess(CreateContractFeeSchedulePage)
            ),
          },
          {
            path: "view/:id/contracts/:contractId/preview",
            element: React.createElement(
              withContractsLibraryAccess(ContractPreviewPage)
            ),
          },
          {
            path: "view/:id/contracts/:contractId/edit",
            element: React.createElement(
              withContractsLibraryAccess(EditContractFeeSchedulePage)
            ),
          },
          {
            path: "view/:id/contracts/:contractId",
            element: React.createElement(
              withContractsLibraryAccess(ContractViewPage)
            ),
          },
        ],
      },
      {
        path: "/patients",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<PatientsPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
        ],
      },
      {
        path: "/providers",
        children: [
          { path: "new", element: <CreateProvider /> },
          {
            path: "edit/:providerId",
            element: <EditProvider />,
          },
        ],
      },
      {
        path: "/orders",
        children: [
          { index: true, element: <OrdersPage /> },
          { path: ":id", element: <OrderViewPage /> },
          { path: "new", element: <CreateOrder /> },
          { path: "copy/:id", element: <CopyOrder /> },
          { path: "review/:draftId", element: <ReviewOrder /> },
        ],
      },
      {
        path: "/reports",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<Reports />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
        ],
      },
      {
        path: "/fee-schedule",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<FeeSchedulePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "new",
            element: (
              <WithRoleProtection
                component={<CreateFeeSchedulePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
        ],
      },
      {
        path: "/users",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<UsersPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "new",
            element: (
              <WithRoleProtection
                component={<CreateEditUser />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "edit/:id",
            element: (
              <WithRoleProtection
                component={<CreateEditUser />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
        ],
      },
      {
        path: "/customize",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<ListCustoms />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: ":id",
            element: (
              <WithRoleProtection
                component={<CustomizePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "new/:id",
            element: (
              <WithRoleProtection
                component={<CustomizePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
        ],
      },
      {
        path: "/payer-rules",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<PayerRules />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "mppr/new",
            element: (
              <WithRoleProtection
                component={<CreatePayerRulesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "mppr/edit/:id",
            element: (
              <WithRoleProtection
                component={<EditPayerRulesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "mppr/copy/:id",
            element: (
              <WithRoleProtection
                component={<CopyPayerRulesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "case-rate/new",
            element: (
              <WithRoleProtection
                component={<CreateCaseRateRulesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "case-rate/edit/:id",
            element: (
              <WithRoleProtection
                component={<EditCaseRateRulesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "case-rate/copy/:id",
            element: (
              <WithRoleProtection
                component={<CopyCaseRateRulesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "packages/new",
            element: (
              <WithRoleProtection
                component={<CreatePackagesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "packages/edit/:id",
            element: (
              <WithRoleProtection
                component={<EditPackagesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "packages/copy/:id",
            element: (
              <WithRoleProtection
                component={<CopyPackagesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "exploding-fee-schedules/new",
            element: (
              <WithRoleProtection
                component={<CreateExplodingFeeSchedulePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "exploding-fee-schedules/edit/:id",
            element: (
              <WithRoleProtection
                component={<EditExplodingFeeSchedulePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "exploding-fee-schedules/copy/:id",
            element: (
              <WithRoleProtection
                component={<CopyExplodingFeeSchedulePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "professional-rulesets/new",
            element: (
              <WithRoleProtection
                component={<CreateProfessionalRulesetPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "professional-rulesets/edit/:id",
            element: (
              <WithRoleProtection
                component={<EditProfessionalRulesetPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "professional-modifiers/new",
            element: (
              <WithRoleProtection
                component={<CreateProfessionalModifierPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "professional-modifiers/edit/:id",
            element: (
              <WithRoleProtection
                component={<EditProfessionalModifierPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "lesser-of-charges/new",
            element: (
              <WithRoleProtection
                component={<CreateLesserOfChargesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "lesser-of-charges/edit/:id",
            element: (
              <WithRoleProtection
                component={<EditLesserOfChargesPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "inpatient-rulesets/new",
            element: (
              <WithRoleProtection
                component={<CreateInpatientRulesetPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "inpatient-rulesets/edit/:id",
            element: (
              <WithRoleProtection
                component={<EditInpatientRulesetPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "inpatient-rulesets/copy/:id",
            element: (
              <WithRoleProtection
                component={<CopyInpatientRulesetPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "payer/new",
            element: (
              <WithRoleProtection
                component={<CreatePayerPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "payer/edit/:id",
            element: (
              <WithRoleProtection
                component={<EditPayerPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "contracts/new",
            element: (
              <WithRoleProtection
                component={<CreateContractFeeSchedulePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "contracts/:id",
            element: (
              <WithRoleProtection
                component={<ContractViewPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "contracts/:id/edit",
            element: (
              <WithRoleProtection
                component={<EditContractFeeSchedulePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "contracts/:id/preview",
            element: (
              <WithRoleProtection
                component={<ContractPreviewPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "market-prices",
            element: (
              <WithRoleProtection
                component={<AllMarketPrices />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "market-prices/upload",
            element: (
              <WithRoleProtection
                component={<MarketPricesUpload />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "market-prices/edit/:id",
            element: (
              <WithRoleProtection
                component={<MarketPricesEdit />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "market-prices/:id",
            element: (
              <WithRoleProtection
                component={<MarketPricesView />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "custom-cpt-volume/:id",
            element: (
              <WithRoleProtection
                component={<CustomCptVolumeDetailPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "hierarchy-rules/new",
            element: (
              <WithRoleProtection
                component={<HierarchyRulesetPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "hierarchy-rules/ruleset/:providerId/:payerId",
            element: (
              <WithRoleProtection
                component={<HierarchyRulesetPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
        ],
      },
      {
        path: "/revenue-dashboard",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<RevenueDashboard />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
        ],
      },
      {
        path: "/chatbot",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<Chatbot />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "models",
            element: (
              <WithRoleProtection
                component={<Chatbot />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "files",
            element: (
              <WithRoleProtection
                component={<Chatbot />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "chats",
            element: (
              <WithRoleProtection
                component={<Chatbot />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "ai-prompt",
            element: (
              <WithRoleProtection
                component={<Chatbot />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "models/new",
            element: (
              <WithRoleProtection
                component={<CreateModelPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "models/:modelId",
            element: (
              <WithRoleProtection
                component={<ModelViewPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "models/edit/:modelId",
            element: (
              <WithRoleProtection
                component={<EditModelPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "files/upload",
            element: (
              <WithRoleProtection
                component={<UploadFilePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "files/:fileId",
            element: (
              <WithRoleProtection
                component={<FileDetailPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "files/:fileId/edit",
            element: (
              <WithRoleProtection
                component={<EditFilePage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
          {
            path: "chats/:chatId",
            element: (
              <WithRoleProtection
                component={<ChatViewPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
        ],
      },
      {
        path: "/hst-sync",
        children: [
          {
            index: true,
            element: (
              <WithRoleProtection
                component={<HstSyncPage />}
                allowedRoles={[UserRole.SUPER_ADMIN]}
              />
            ),
          },
        ],
      },
    ],
  },
  {
    path: "/order",
    element: <PublicLayout />,
    children: [
      {
        path: ":id",
        element: <OrderOverview variant={Steps.ORDER_OVERVIEW} />,
      },
      {
        path: "update/:id",
        element: <OrderUpdate variant={OrderUpdateSteps.ORDER_UPDATE} />,
      },
      {
        path: "pay/:id",
        element: <PayMoreSection variant={OrderPayMoreSteps.PAY_MORE} />,
      },
      { path: "direct-pay", element: <DirectPay /> },
    ],
  },
  {
    path: "/dp/:linkId",
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <DirectPay />,
      },
    ],
  },
  {
    path: "/receipt",
    element: <PublicLayout />,
    children: [
      {
        path: ":id",
        element: <VerificationPage variant={VerificationSteps.RECEIPT} />,
      },
    ],
  },
  {
    path: "/confirmation",
    element: <PublicLayout />,
    children: [
      {
        path: ":id",
        element: (
          <VerificationPage variant={VerificationSteps.HOSPITAL_CONFIRMATION} />
        ),
      },
      {
        path: "success",
        element: <ConfirmationSuccess />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
